import { filter } from 'lodash';
import { useState } from 'react';
import {
  Box,
  Card,
  Table,
  TableRow,
  TableBody,
  TableCell,
  Typography,
  TableContainer,
  TablePagination,
  Divider,
  Chip
} from '@mui/material';
import { addOneDay, fDate, fDateN, fDateTime } from '../../../../../utils/formatTime';
import Page from '../../../../Page';
import Scrollbar from '../../../../Scrollbar';
import SearchNotFound from '../../../../SearchNotFound';
import { ProductListHead } from '../../../e-commerce/product-list';
import EnvioListToolbar from '../../../paquetes/EnvioListToolbar';
import { useFilterByDate } from '../../../../../hooks/useFilterByDate';
import useHandleFiltroFecha from '../../../../../hooks/useHandleFiltroFecha';
import ButtonPdfMultimarcas from '../../../../atomos/ButtonPdfMultimarcas';
import { MenuItemsButton } from '../../../../atomos/MenuItemsButoon';
import { MenuDetalleButtonButton } from '../../../../atomos/MenuDetalleButton';
import { useSelector } from 'react-redux';
import useAuthUsers from '../../../../../hooks/useAuthUsers';

const TABLE_HEAD = [
  { id: '', label: 'Ver', alignRight: false },
  { id: 'id', label: '#', alignRight: false },
  { id: 'created_at', label: 'Fecha', alignRight: false },
  { id: 'lic', label: 'Licenciatario', alignRight: false },
  { id: 'usuario', label: 'Usuario', alignRight: false },
  { id: 'remitenteNombre', label: 'Nombre Remitente', alignRight: false },
  { id: 'remitenteTelefono', label: 'Telefono', alignRight: false },
  { id: 'status', label: 'status', alignRight: false },
  { id: 'todo', label: 'Recibo Pdf', alignRight: false },
  { id: 'ipaqueteria', label: 'Paquetería', alignRight: false }
];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });

  if (query) {
    return filter(array, (_product) => _product?.id?.toString().toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }

  return stabilizedThis.map((el) => el[0]);
}

export default function ListaRepartosMultimarca({ paquetes = [], userIds }) {
  const [page, setPage] = useState(0);
  const { userList } = useSelector((state) => state.dagpacket);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [orderBy, setOrderBy] = useState('createdAt');
  const [statusEnvioSelected, setStatusEnvioSelected] = useState([]);
  const { currentUser } = useAuthUsers();

  const [fecha, setFecha] = useState('');

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = paquetes.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - paquetes.length) : 0;

  const filterDate = (data, date) => {
    if (date.length > 0) {
      // return data.filter((item) => item.created_at.toDate().toISOString().substring(0, 10) === date);
      return data.filter((item) => fDateN(item.created_at) <= date);
    }
    return data;
  };

  const filterStatus = (data, status) => {
    if (status === 'QUOTE') {
      return data.filter((item) => item.status === status || item.status === 'PURCHASE');
    }
    if (status === 'LABEL_CREATED') {
      return data.filter((item) => item.status === status || item.status === 'CREATED');
    }
    if (status === 'PENDIENTE-CANCELACION') {
      return data.filter((item) => item.state === 'PENDIENTE-CANCELACION');
    }
    if (status === 'CANCELADO') {
      return data.filter((item) => item.status === 'CANCELADO');
    }

    return data;
  };

  const handleStatus = (selectedStatuses) => {
    setStatusEnvioSelected(selectedStatuses);
  };

  const { handleDesde, handleHasta, handleResetFechas, hasta, desde } = useHandleFiltroFecha();
  const newHasta = addOneDay(hasta);

  console.log({ fecha });
  console.table({ desde, newHasta });

  const filteredByStatus = filterStatus(paquetes, statusEnvioSelected);

  const filteredByDate = filterDate(filteredByStatus, fecha);

  const filteredProducts = applySortFilter(filteredByDate, getComparator(order, orderBy), filterName);

  // TODO! Filtrar por updated_at o create_at?

  // const { filteredData } = useFilterByDate(filteredProducts, desde, newHasta, 'updated_at');
  const { filteredData } = useFilterByDate(filteredProducts, desde, newHasta, 'created_at');

  const isProductNotFound = filteredProducts.length === 0;

  console.log({ filteredData });

  return (
    <Page title="Licenciatarios - Reparto Multimarca">
      <Card>
        <Box display="flex" justifyContent="center" sx={{ margin: '15px 0' }}>
          <Typography component="h2" variant="h4">
            Reparto Multimarca
          </Typography>
        </Box>
        <Divider />
        <EnvioListToolbar
          numSelected={selected.length}
          filterName={filterName}
          onFilterName={handleFilterByName}
          date={fecha}
          setDate={setFecha}
          handleStatus={handleStatus}
          onDesdeDate={handleDesde}
          onHastaDate={handleHasta}
          hasFilterDate
          hasReporte={currentUser.role === 'almighty' || currentUser.role === 'administrativo'}
          desde={desde}
          hasta={hasta}
          handleResetFechas={handleResetFechas}
          statusEnvioSelected={statusEnvioSelected}
          desdeSection="multimarca"
          userIds={userIds}
        />

        <Scrollbar>
          <TableContainer sx={{ minWidth: 800 }}>
            <Table>
              <ProductListHead
                order={order}
                orderBy={orderBy}
                headLabel={TABLE_HEAD}
                rowCount={paquetes.length}
                numSelected={selected.length}
                onRequestSort={handleRequestSort}
                onSelectAllClick={handleSelectAllClick}
                checkbox={false}
              />
              <TableBody>
                {filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                  const { tracking, paquetes, remitente, created_at, updated_at, status, userId } = row;
                  const createDate = created_at.value
                    ? fDate(new Date(created_at.value))
                    : fDateTime(created_at.toDate());

                  return (
                    <TableRow key={tracking}>
                      {/* //Todo EditButton or selectButton */}
                      <TableCell>
                        <MenuDetalleButtonButton data={row} />
                      </TableCell>
                      <TableCell>{tracking}</TableCell>

                      <TableCell>{createDate}</TableCell>
                      <TableCell>{row.hostUserDisplayName ? row.hostUserDisplayName : '-'}</TableCell>
                      <TableCell>
                        {row.userDisplayName || userList.find((user) => user.id === userId)?.displayName || ''}
                      </TableCell>
                      <TableCell>{remitente.nombreRemitente}</TableCell>
                      <TableCell>{remitente.telefonoRemitente}</TableCell>
                      <TableCell sx={{ textAlign: 'center' }}>
                        <Chip
                          label={status || 'Desconocido'}
                          variant="outlined"
                          color="secondary"
                          sx={{ fontWeight: '600' }}
                        />
                      </TableCell>
                      <TableCell>
                        <ButtonPdfMultimarcas data={row} />
                      </TableCell>
                      <TableCell>
                        <MenuItemsButton data={paquetes} />
                      </TableCell>
                    </TableRow>
                  );
                })}
                {emptyRows > 0 && (
                  <TableRow style={{ height: 53 * emptyRows }}>
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
              {isProductNotFound && (
                <TableBody>
                  <TableRow>
                    <TableCell align="center" colSpan={6}>
                      <Box sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={filterName} />
                      </Box>
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          </TableContainer>
        </Scrollbar>

        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={filteredData.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Card>
    </Page>
  );
}
